export type TestLog = {
  scenario: string;
  platform: string;
  timestamp: number;
  steps: Array<{ name: string; ok: boolean; dbSnapshot?: any; removed?: any }>
};

export class TestLogger {
  private log: TestLog;

  constructor(scenario: string, platform: string) {
    this.log = { scenario, platform, timestamp: Date.now(), steps: [] };
  }

  step(name: string, ok: boolean, extra?: { dbSnapshot?: any; removed?: any }) {
    this.log.steps.push({ name, ok, ...(extra || {}) });
  }

  toJSON(): TestLog {
    return this.log;
  }
}


